export interface QuickBooksLogRecordConstructor {
  id: number
  referenceId: Nullable<string> // id of the record the log refers to (error logs only)
  description: string
  timestamp: ISODateString // rendered as long-form date (LLLL)
  modelType: Nullable<string> // internal_type.model, lowercase, e.g. 'itemreceipt'; null when the row has no internal type
}

export class QuickBooksLogRecord {
  readonly id: number
  readonly referenceId: Nullable<string>
  readonly description: string
  readonly timestamp: Date
  readonly modelType: Nullable<string>

  constructor(data: QuickBooksLogRecordConstructor) {
    this.id = data.id
    this.referenceId = data.referenceId
    this.description = data.description
    this.timestamp = new Date(data.timestamp)
    this.modelType = data.modelType
  }
}
